import React from 'react';
import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { formatLongDateTimeStringToDateTimeObject } from '@common/Util';
import LanguageAndFlag from '@components/LanguageAndFlag/LanguageAndFlag';
import { useGlobalContext } from '@hooks/Context/GlobalContext';

const StyledBox = styled(Box)(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    display: 'inherit'
  }
}));

const StyledNoWrap = styled('span')(() => ({
  whiteSpace: 'nowrap'
}));

const ComponentHeader = ({ eventData, availableSeats = 0, dialogHeader = false }) => {
  const [contextData] = useGlobalContext();
  return (
    <>
      <StyledBox textAlign={dialogHeader ? 'left' : 'center'}>
        <Typography
          variant={dialogHeader ? 'h4' : 'body1'}
          display={dialogHeader ? 'block' : 'inline'}
          sx={{ mr: { xs: 0, sm: 2 } }}
        >
          {eventData?.name}
        </Typography>
        <Typography sx={{ paddingRight: { xs: 0, sm: '1rem' } }} display='inline'>
          {formatLongDateTimeStringToDateTimeObject(eventData?.startDateTime) + ' - '}
          <StyledNoWrap>
            {formatLongDateTimeStringToDateTimeObject(eventData?.endDateTime)}
          </StyledNoWrap>
        </Typography>
        <LanguageAndFlag nativeLanguages={get(eventData, 'nativeLanguages')} />
        <Typography variant='body1' display='inline' sx={{ mr: { xs: 0, sm: 2 } }}>
          {`${Localize.get('CustomerLoyaltyEvents.waitingList')}: ${Localize.get(eventData.hasWaitingList ? 'Booking.on' : 'Booking.off')}`}
        </Typography>

        <Chip
          display='inline'
          sx={{ fontWeight: 'normal', fontSize: '1rem' }}
          label={
            availableSeats === 0 ? (
              Localize.get('Catalog.fullybooked')
            ) : contextData?.isSeatsNumber ? (
              <>
                <Typography
                  component={'span'}
                  display='inline'
                >{`${Localize.get('CourseDetails.availableSeats')}: `}</Typography>
                <Typography component={'span'} display='inline' color='primary.main'>
                  {`${availableSeats}`}
                </Typography>
              </>
            ) : (
              Localize.get('Catalog.seatsAvailable')
            )
          }
        />
      </StyledBox>
    </>
  );
};
export default ComponentHeader;
